<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-lg-8 col-sm-12">
          <div class="element-box mb-0">
            <form @submit="refresh">
              <h5 class="form-header">REPORTE INVENTARIO NEGATIVO EN TIENDA</h5>
              <div class="row">
                <div class="col-md-12">
                  <TiendaSelectComponent :current="current" />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="dropdown">
                    <br />
                    <button v-if="current.tienda" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                      class="btn btn-info dropdown-toggle" aria-expanded="false">
                      <i class="fas fa-download"></i>
                      Generar Reporte
                    </button>
                    <div aria-labelledby="dropdownMenuButton" class="dropdown-menu" x-placement="bottom-start" style="
                        position: absolute;
                        transform: translate3d(0px, 30px, 0px);
                        top: 0px;
                        left: 0px;
                        will-change: transform;
                      ">
                      <a @click="actualizarExistencia(current, 'pdf')" class="dropdown-item"><i
                          class="fas fa-long-arrow-alt-right" style="font-size: 10px;"></i>&nbsp;
                        PDF
                        <i class="far fa-file-pdf"></i></a>
                      <a @click="actualizarExistencia(current, 'xls')" class="dropdown-item"><i
                          class="fas fa-long-arrow-alt-right" style="font-size: 10px;"></i>&nbsp;
                        XLS
                        <i class="far fa-file-excel"></i></a>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            <div class="row">
              <div class="col-sm-12"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import DynamicService from "@/services/commons/DynamicService";
import ProductoTiendaTableComponent from "@/components/cat/productos/ProductoTiendaTableComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
    ProductoSelectComponentV2,
    ProductoTiendaTableComponent,
  },
  data() {
    return {
      current: {
        tienda: null,
        errors: [],
      },
      datos: [],
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  watch: {
    $route(to, from) {
      if (this.$route.params.tienda) {
        this.current.tienda = this.$route.params.tienda;
        this.refresh();
      }
    },
  },
  mounted() {
    let self = this;
  },
  methods: {
    actualizarExistencia(current, type_file) {
      let self = this;
      DynamicService.postActionList(
        "cat",
        "productos",
        "actualizar_existencias_negativas_x_tienda",
        current
      )
        .then((response) => {
          if (type_file == "pdf") {
            self.GenerarReportePdf(current);
          }
          if (type_file == "xls") {
            self.GenerarReporteXls(current);
          }
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    },
    GenerarReportePdf(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?&report_name=inventario/inv_negativo/inventario_negativo2.jrxml&tienda=${current.tienda}`
      );
    },
    GenerarReporteXls(current) {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=inventario/inv_negativo/inventario_negativo.jrxml&tienda=${current.tienda}`
      );
    },
    refresh(e) {
      if (e) {
        e.preventDefault();
      }
      let self = this;
      let params = Object.assign({}, self.current);
      DynamicService.postAction(
        "cat",
        "productos",
        self.current.producto.sku,
        "kardex_x_fecha_json",
        params
      )
        .then((res) => {
          self.datos = res.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
